var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lyf-ui-switch",class:{ checked: _vm.value },style:({
  width: _vm.customSize.switchW,
  height: _vm.customSize.switchH,
  backgroundColor: _vm.customColor,
  borderColor: _vm.customColor
}),on:{"click":_vm.switchClick}},[_c('div',{staticClass:"lyf-ui-switch-dot",style:({ width: _vm.customSize.dotW, height: _vm.customSize.dotH })})])
}
var staticRenderFns = []

export { render, staticRenderFns }